
import NavBarButton from './NavBarButton.vue'

export default {
  name: 'NavBar',
  components: {
    NavBarButton,
  },
  props: {
    isOpened: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isOpenedDesktop: false,
      isMobile: false,
      subCategoriesSimulated: false,
      navBarLinks: [
        { name: 'Home', link: '/', icon: 'fa-solid fa-house', exact: true },
        {
          name: 'Mural de recados',
          link: '/messagewall',
          icon: 'fa-solid fa-comments',
        },
        {
          name: 'Materiais',
          link: '/materials',
          icon: 'fa-solid fa-file',
        },
        {
          name: 'Videoaulas',
          link: '/videos',
          icon: 'fa-solid fa-video',
        },
        // {
        //   name: 'Planejamento',
        //   link: '/planning',
        //   icon: 'fa-solid fa-calendar-range',
        // },
        {
          name: 'Caderno de Erros',
          link: '/errorsBook',
          icon: 'fa-solid fa-book',
        },
        {
          name: 'Megecast',
          link: '/megecast',
          icon: 'fa-solid fa-podcast',
        },
        {
          name: 'Simulados',
          active: '/simulados',
          icon: 'fa-solid fa-file-lines',
          class: 'h-40',
          childLinks: [
            {
              name: 'Para resolução',
              link: '/simulados',
              exact: true,
              icon: 'fa-solid fa-list',
            },
            {
              name: 'Respondidos',
              link: '/simulados/simulatedResult',
              icon: 'fa-solid fa-check',
            },
            {
              name: 'Gabarito comentado',
              link: '/simulados/gabarito-comentado',
              icon: 'fa-solid fa-file-circle-check',
              isNew: true,
            },
          ],
        },
        {
          name: '2a fase/Prova Oral',
          active: '/exam',
          class: 'h-24',
          icon: 'fa-solid fa-file-pen',
          childLinks: [
            {
              name: 'Para resolução',
              link: '/exam/exams',
              icon: 'fa-solid fa-pencil',
            },
            {
              name: 'Correções',
              link: '/exam/correction',
              icon: 'fa-solid fa-person-chalkboard',
            },
          ],
        },
        {
          name: 'Painel dinâmico',
          link: '/painel_dinamico',
          icon: 'fa-solid fa-gauge',
          novo: true,
        },
      ],
      links: {
        name: 'Suporte ao aluno',
        link: '/suport',
        icon: 'fa-solid fa-phone',
      },
    }
  },
  computed: {
    computedClass() {
      const baseClass =
        'transition-ease-out hide-scroll bg-blue-main overflow-y-scroll'
      const mobileClass = this.isMobile
        ? this.isOpened
          ? '!w-full position z-50'
          : '!w-0'
        : this.isTablet
        ? this.isOpened
          ? '!w-100 position z-50'
          : '!w-20'
        : this.isOpened
        ? '!w-full position sm:!w-80 z-50'
        : '!w-20'
      return `${baseClass} ${mobileClass}`
    },
    user() {
      return this.$store.getters['credential/user']
    },
  },
  mounted() {
    this.getServices()
    this.updateDeviceType()
    window.addEventListener('resize', this.updateDeviceType)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDeviceType)
  },
  methods: {
    updateDeviceType() {
      const width = window.innerWidth
      this.isMobile = width <= 768
      this.isTablet = width > 768 && width <= 1024
      this.setInitialNavBarState()
    },
    closeHeader(modal) {
      if (modal) {
        this.$store.commit('modal/toggleClassModal')
      }
      if (this.isMobile) {
        this.$store.commit('navbar/closeNavBar')
      }
    },
    toggleNavBar() {
      this.$store.commit('navbar/toggleNavBar')
    },
    getServices() {
      if (localStorage.questions) {
        this.navBarLinks.splice(2, 0, {
          name: 'Banco de questões',
          link: '',
          icon: 'fa-solid fa-comment-question',
          redirectToQuestions: true,
          beta: true,
        })
      }
      if (localStorage.multiAgentIa) {
        this.navBarLinks.splice(2, 0, {
          name: 'Professores IA',
          link: '/IA',
          icon: 'fa-regular fa-microchip-ai',
          beta: true,
        })
      }
      if (localStorage.planningIa) {
        this.navBarLinks.splice(3, 0, {
          name: 'Planejamento',
          link: '/planning',
          icon: 'fa-regular fa-calendar-days',
          beta: true,
        })
      }
    },
    setInitialNavBarState() {
      if (this.isMobile || this.isTablet) {
        this.$store.commit('navbar/closeNavBar')
      } else {
        this.$store.commit('navbar/openNavBar')
      }
    },
  },
}
